import React from 'react'
import PropTypes from 'prop-types'
import { Message, Level, Box } from '@qure/containers'
import './index.scss'

function UnsupportedBrowser(props) {
  const {
    browserDetails: { name: browserName, version, OSName, OSVersion },
    t
  } = props
  const browser = [
    {
      name: 'Chrome',
      logoURL: '/browsersLogos/chrome.png',
      downloadURL: 'https://www.google.com/intl/en_in/chrome/'
    },
    {
      name: 'Firefox',
      logoURL: '/browsersLogos/firefox.png',
      downloadURL: 'https://www.mozilla.org/en-US/firefox/new/'
    },
    {
      name: 'Edge',
      logoURL: '/browsersLogos/edge.jpeg',
      downloadURL: 'https://www.microsoft.com/en-us/edge'
    },
    {
      name: 'Safari',
      logoURL: '/browsersLogos/safari.png',
      downloadURL: ''
    }
  ]

  return (
    <div className="p-4 unsupported-browser-wrapper">
      <div className="ub-container">
        <Message
          iConClass="fas fa-exclamation-triangle fa-3x"
          color="primary"
          title={t('Your current browser is unsupported')}
          subtitle={t(
            'qTrack works with the latest version of Chrome, Firefox, Edge and Safari'
          )}
        >
          <Level className="is-flex is-flex-wrap-wrap">
            {browser.map(({ name, downloadURL, logoURL }) => {
              return (
                <BrowserBox
                  name={name}
                  downloadURL={downloadURL}
                  logoURL={logoURL}
                />
              )
            })}
          </Level>
          <div className="is-size-7 has-text-grey-light">
            {browserName} {version} | {OSName} {OSVersion}
          </div>
        </Message>
      </div>
    </div>
  )
}

const BrowserBox = props => {
  const { name, downloadURL, logoURL } = props
  return (
    <Level.Item>
      <Box className="content is-shadowless pt-0">
        <img src={logoURL} alt={name} style={{ width: '60px' }} />
        <div className="is-size-6 has-text-black has-text-weight-bold">
          {name}
        </div>
        <If condition={name !== 'Safari'}>
          <a
            href={downloadURL}
            target="_blank"
            rel="noreferrer"
            className="is-size-7"
          >
            Download latest
          </a>
          <Else />
          <span className="is-size-7"> iOS 12+ or macOS</span>
        </If>
      </Box>
    </Level.Item>
  )
}

BrowserBox.propTypes = {
  name: PropTypes.string.isRequired,
  downloadURL: PropTypes.string.isRequired,
  logoURL: PropTypes.string.isRequired
}

UnsupportedBrowser.defaultProps = {
  browserDetails: {}
}

UnsupportedBrowser.propTypes = {
  t: PropTypes.func.isRequired,
  browserDetails: PropTypes.object
}

export default UnsupportedBrowser
